import { Inject, Injectable } from "@angular/core";
import { STARTUP_CONTEXT_TOKEN, StartupContext } from "@obg/ngx.core";
import { CookieService, TelemetryService } from "@obg/ngx.global.evo";

import { ABExperimentConfigService } from "./a-b.experiment.config";

@Injectable({
	providedIn: "root",
})
export class ABExperimentService {
	private readonly experimentToVariantMap = this.parseCookie();

	private labelToIdentifierMap = this.abExperimentConfig.getLabelToIdentifierMap();
	private labelToConfigMap = this.abExperimentConfig.getLabelToConfigMap();
	private countryCode = this.startupContext.appContext.countryCode;

	private sentExperimentVariantEvents: string[] = [];

	constructor(
		private cookieService: CookieService,
		private telemetryService: TelemetryService,
		private abExperimentConfig: ABExperimentConfigService,
		@Inject(STARTUP_CONTEXT_TOKEN) private startupContext: StartupContext
	) {}

	getExperimentVariant(label: string): string | undefined {
		const identifier = this.labelToIdentifierMap[label];
		const variant = this.experimentToVariantMap[identifier];
		if (!identifier) {
			return undefined;
		}
		if (!this.isExperimentActive(label)) {
			return undefined;
		}

		if (!this.sentExperimentVariantEvents.includes(label)) {
			this.telemetryService.track({
				expId: identifier,
				expVar: variant,
			});
			this.telemetryService.track({
				event: `ExperimentActivate_${label}`,
			});

			this.sentExperimentVariantEvents.push(label);
		}

		return variant;
	}

	private parseCookie(): Record<string, string> {
		const cookie = this.cookieService.get("OBG-EXPERIMENT-VARIANT-MAP") ?? "";
		return cookie
			.split("!")
			.map((variant) => variant.split("."))
			.reduce((map, [experiment, variant]) => ({ ...map, [experiment]: variant }), {});
	}

	private isExperimentActive(label: string): boolean {
		const config = this.labelToConfigMap[label];
		if (!config) {
			return false;
		}
		if (
			this.countryCode &&
			(config.country?.include?.includes(this.countryCode) === false ||
				config.country?.exclude?.includes(this.countryCode))
		) {
			return false;
		}
		return true;
	}
}
